import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const {
  EDIT_MY_AVAILABILITY_SUCCESS,
  EDIT_MY_AVAILABILITY_FAILURE,
  EDIT_MY_AVAILABILITY_LOADING,
  EDIT_MY_AVAILABILITY_RESET,
} = getMyAvailabilityConstants;

const intialState: object = {
  response: null,
  isGetAvailability: false,
  loading: false,
};

export const editMyAvailabilityReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case EDIT_MY_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: true,
        loading: false,
      };
    }
    case EDIT_MY_AVAILABILITY_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: false,
        loading: false,
      };
    }

    case EDIT_MY_AVAILABILITY_LOADING:
      return {
        ...state,
        loading: true,
      };

    case EDIT_MY_AVAILABILITY_RESET:
      return {
        ...state,
        response: null,
        isGetAvailability: false,
        loading: false,
      };

    default:
      return state;
  }
};
